import { AppContext } from "..";
import { useContext } from "react";

const ButtonDelete = ({ id }) => {
  const { deleteProduct } = useContext(AppContext);

  return (
    <div className="product__controls">
      <button
        type="button"
        onClick={() => {
          deleteProduct(id);
        }}
      >
        <img src="./img/icons/cross.svg" alt="Delete" />
      </button>
    </div>
  );
};

export default ButtonDelete;
